import React from 'react';
import EmployeeDashboard from '../components/dashboard/EmployeeDashboard';

const Dashboard = () => {
  return <EmployeeDashboard />;
};

export default Dashboard;
